import React, { useEffect, useState, useRef, useLayoutEffect } from 'react';
import { GoogleMap, LoadScript, DrawingManager, Circle, Polygon } from '@react-google-maps/api';


const drawingLibraries = ['drawing']; // keep outside of component so it doesn't cause the map to re-render

function DrawableMap(props) {
    const mapRef = useRef(null);
    const [center, setCenter] = useState(props.center == null ? '' : props.center);
    const GOOGLE_MAPS_API_KEY = 'AIzaSyDqNnSuRDD3nyJ-oVOY4jV7McgqBIDyId0';

    useEffect(() => {
       // console.log('props changed');
        try {
            if (mapRef.current != null) {
                let bounds = new window.google.maps.LatLngBounds();
                for (let i = 0; i < props.serviceAreas.length; i++) {
                    bounds.extend(props.serviceAreas[i].props.center);
                }

                mapRef.current.fitBounds(bounds);
            }
        }
        catch {

        }
     

    }, [props]);


    //if (window.google === undefined) {
    //    return <LoadScript
    //        googleMapsApiKey={GOOGLE_MAPS_API_KEY}
    //        libraries={drawingLibraries}
    //    >
    //        <GoogleMap
    //            ref={mapRef}
    //            mapContainerStyle={{ width: props.width, height: '500px' }}
    //            options={{
    //                streetViewControl: false,
    //                panControl: false,
    //                overviewMapControl: false,
    //                mapTypeControl: false,
    //                fullscreenControl: false
    //            }}
    //            center={center}
    //            zoom={10}
    //        >
    //            { /* Child components, such as markers, info windows, etc. */}
    //            {props.serviceAreas}
    //            <DrawingManager
    //                drawingMode={props.isDrawing ? 'circle' : ''}
    //                onCircleComplete={props.onCircleComplete}
    //                options={{
    //                    drawingControlOptions: {

    //                        drawingModes: []
    //                    }
    //                }}
    //            />
    //        </GoogleMap>
    //    </LoadScript>
    //}
    //else {
        console.log('google is defined');
        return <div>
            <GoogleMap
                ref={mapRef}
                mapContainerStyle={{ width: props.width, height: '500px' }}
                options={{
                    streetViewControl: false,
                    panControl: false,
                    overviewMapControl: false,
                    mapTypeControl: false,
                    fullscreenControl: false
                }}
                center={center}
                zoom={10}
            >
                { /* Child components, such as markers, info windows, etc. */}
                {props.serviceAreas}
                <DrawingManager
                    drawingMode={props.isDrawing ? 'circle' : ''}
                    onCircleComplete={props.onCircleComplete}
                    options={{
                        drawingControlOptions: {

                            drawingModes: []
                        }
                    }}
                />
            </GoogleMap>
        </div>
    //}

  
}
export default React.memo(DrawableMap);